/**
 * @description 楽天トラベルカスタマイズページ用の調整
 */
export function setRakuten() {
  $('html').css('font-size', '62.5%');
}
